import React from 'react';
import {
  Armchair,
  AlertCircle,
  Brain,
  TrendingDown,
  Activity,
  Clock,
} from 'lucide-react';
import { mockData } from '../../mock';

const ICON_MAP = {
  Armchair,
  AlertCircle,
  Brain,
  TrendingDown,
  Activity,
  Clock,
};

const ModernChallengeSection = () => {
  const { modernChallenge } = mockData;

  return (
    <section
      id="challenge"
      className="section-padding bg-subtle"
      data-testid="modern-challenge-section"
    >
      <div className="container">
        <div className="text-center mb-12">
          <h2 className="section-title">{modernChallenge.title}</h2>
          <p className="section-subtitle">{modernChallenge.description}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {modernChallenge.challenges.map((challenge) => {
            const Icon = ICON_MAP[challenge.icon] || Activity;
            return (
              <div
                key={`challenge-${challenge.title}`}
                className="reason-card"
                data-testid={`challenge-card-${challenge.title.toLowerCase().replace(/\s+/g, '-')}`}
              >
                <div
                  className="service-icon"
                  style={{ marginBottom: '1rem' }}
                  aria-hidden="true"
                >
                  <Icon size={28} />
                </div>
                <h3 className="reason-title">{challenge.title}</h3>
                <p className="reason-description">{challenge.description}</p>
              </div>
            );
          })}
        </div>

        <div className="text-center mt-12 max-w-3xl mx-auto">
          <p
            className="section-description"
            style={{
              fontStyle: 'italic',
              color: 'var(--text-secondary, rgba(255,255,255,0.85))',
            }}
            data-testid="challenge-solution-statement"
          >
            {modernChallenge.solution}
          </p>
        </div>
      </div>
    </section>
  );
};

export default ModernChallengeSection;
